import React, { Fragment, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { IconCheck, IconClose } from "~/components/icons";
import ModalGetOut from "~/components/ModalGetOut";

import api from "~/services/api";
import { removeToken } from "~/services/token";
import { formatDocument } from "~/services/utils";
import * as MeActions from "~/store/modules/me/actions";
import { configs } from "~/store/modules/configs/actions";

import config from "../../config";
import Loading from "../Loading";

import "./Navbar.scss";

export const Navbar = ({ typeOfAccess }) => {
  const [userInfoVisible, setUserInfoVisible] = useState(false);
  const [userVoteInfo, setUserVoteInfo] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [modalGetOut, setModalGetOut] = useState(false);

  const history = useHistory();
  const { guid } = useParams();
  const dispatch = useDispatch();

  const me = useSelector((store) => store.me.me);
  const user_rules = useSelector((store) => store.user_rules.user_rules);
  const logo = useSelector((store) => store.configs.website.logo);

  useEffect(() => {
    if (me.branch_info) {
      if (config.domainLogos) {
        const newLogo = config.domainLogos[me.branch_info.branch];
        if (newLogo) {
          dispatch(configs({ logo: newLogo }));
        }
      }
    }
  }, [me]);

  useEffect(() => {
    function fetchVotes() {
      if (guid) {
        setIsLoading(true);
        setUserVoteInfo([]);
        api
          .get(`/v1/livestreams/${guid}/polls/check`)
          .then(({ data }) => {
            setUserVoteInfo(data);
          })
          .catch((error) => {
            if (error && error.response && error.response.status === 401) {
              logout();
            }
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    }

    if (userInfoVisible) fetchVotes();
  }, [userInfoVisible]);

  function logout(event) {
    if (event) event.preventDefault();
    removeToken();
    dispatch(MeActions.me({}));
    history.push(`/`);
  }

  function renderDocument(document) {
    const { label, value } = formatDocument(document);

    return (
      <>
        <h5>{label}</h5>
        <p>{value}</p>
      </>
    );
  }

  return (
    <Fragment>
      {modalGetOut && (
        <ModalGetOut
          onError={() => setModalGetOut(false)}
          onSuccess={() => {
            setModalGetOut(false);
            logout();
          }}
        />
      )}
      <div className="container-fluid-navbar">
        <div className="container-logo">
          {typeOfAccess === "qr_code_personal" ? (
            logo && <img src={logo} alt="logo" />
          ) : (
            <Link to="/">{logo && <img src={logo} alt="logo" />}</Link>
          )}
        </div>
        {me && me.name && (
          <div className="container-buttons">
            <div className="profile-container">
              {me?.is_guest ? (
                <div className="profile-button no-cursor">
                  <i className="icon-ic_perfil1-2" />
                  <span>{me?.name}</span>
                </div>
              ) : (
                <div
                  className="profile-button"
                  onClick={() => setUserInfoVisible(!userInfoVisible)}
                >
                  <i className="icon-ic_perfil1-2" />
                  <span>{me?.name}</span>
                  <i className={`icon-${userInfoVisible ? "up" : "down"}`} />
                </div>
              )}

              <div
                className={`profile-box ${userInfoVisible ? "open" : "close"}`}
              >
                <h1 className="profile-title">Dados</h1>
                <ul className="profile-info">
                  {me?.document_number && (
                    <li>{renderDocument(me.document_number)}</li>
                  )}
                  {me?.branch_info?.branch && (
                    <li>
                      <h5>Cooperativa</h5>
                      <p>{me.branch_info.branch}</p>
                    </li>
                  )}
                  {config.showPA && me?.branch_info?.agency && (
                    <li>
                      <h5>PA</h5>
                      <p>{me.branch_info.agency}</p>
                    </li>
                  )}
                  {config.showGroup && Boolean(me?.branch_info?.group) && (
                    <li>
                      <h5>Grupo</h5>
                      <p>{me.branch_info.group}</p>
                    </li>
                  )}
                  {me?.companies?.length > 0 && (
                    <li>
                      <h5>Empresas</h5>
                      {me?.companies.map((company, index) => (
                        <div key={index} className="profile-company">
                          {company.name}
                        </div>
                      ))}
                    </li>
                  )}
                  {isLoading && <Loading size={3} marginAuto />}
                </ul>
                {userVoteInfo && userVoteInfo.length > 0 && (
                  <h1 className="profile-title">Votações</h1>
                )}
                <ul className="profile-info">
                  {userVoteInfo &&
                    userVoteInfo.map((poll) => (
                      <li className="poll-info">
                        <span>{poll.title}</span>
                        {poll.voted ? (
                          <IconCheck color={"#3bb54a"} width="24" heigt="24" />
                        ) : (
                          <IconClose color={"#fa364c"} width="24" heigt="24" />
                        )}
                      </li>
                    ))}
                </ul>
              </div>
            </div>
            {user_rules && (
              <div className="container-info-user-rules">
                <div className="container-info-label">
                  {me?.is_representative ||
                  (me?.is_collaborator && me?.companies.length > 0) ? (
                    <h5>Apto a votar pela empresa</h5>
                  ) : user_rules.allowed ? (
                    <h5>Apto a votar</h5>
                  ) : (
                    <h5>Não apto a votar</h5>
                  )}
                  {user_rules.conditions &&
                    user_rules.conditions.map((con, i) => <p key={i}>{con}</p>)}
                </div>
                <span
                  className={`status ${
                    me?.is_representative ||
                    (me?.is_collaborator && me?.companies.length > 0)
                      ? "companyAllowed"
                      : user_rules?.allowed
                      ? "allowed"
                      : "notAllowed"
                  }`}
                />
              </div>
            )}
            <button
              className="profile-button-get-out"
              onClick={() => setModalGetOut(true)}
            >
              <span>Sair</span>
            </button>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default Navbar;
